import { chanelCustomRoutes } from "./chanel/channel-custom-routes";

type CustomRoutesProps = {
  applicationKey?: string;
};

// アプリIDに応じてカスタムルーティングコンポーネントを出しわける
export const customRoutes = ({ applicationKey }: CustomRoutesProps) => {
  if (applicationKey === "chanel") {
    return chanelCustomRoutes;
  }
  return [];
};
